/**
 * FaustWP plugin: strip deprecated `canonizeResults` from cache.diff() options
 * to silence Apollo Client 3.x deprecation warning until upgrading to AC 4.0.
 * See: https://www.apollographql.com/docs/react/migrating/apollo-client-4-migration
 */
export default function stripCanonizeResultsPlugin() {
  return {
    apply({ addFilter }) {
      addFilter('apolloClientOptions', 'stripCanonizeResults', (apolloClientOptions) => {
        const cache = apolloClientOptions?.cache;
        if (!cache || typeof cache.diff !== 'function') return apolloClientOptions;

        const originalDiff = cache.diff.bind(cache);
        cache.diff = function diff(options) {
          if (options && 'canonizeResults' in options) {
            const { canonizeResults: _removed, ...rest } = options;
            return originalDiff(rest);
          }
          return originalDiff(options);
        };

        return apolloClientOptions;
      });
    },
  };
}
